import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_EditCompany = _resolveComponent("EditCompany")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_UserTable = _resolveComponent("UserTable")!
  const _component_AccountingPeriods = _resolveComponent("AccountingPeriods")!
  const _component_BankConfig = _resolveComponent("BankConfig")!
  const _component_InvoiceThemeEdition = _resolveComponent("InvoiceThemeEdition")!
  const _component_Connectors = _resolveComponent("Connectors")!
  const _component_AccountingWorkspaces = _resolveComponent("AccountingWorkspaces")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ConfigAPI = _resolveComponent("ConfigAPI")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_BoniMali = _resolveComponent("BoniMali")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        grow: "",
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        style: {"background":"#f4f4f4","border-radius":"16px","overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            ripple: "",
            value: "Company",
            href: "#Company",
            "data-cy": "CompanyEdition-company"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("settings.company")), 1)
            ]),
            _: 1
          }),
          (_ctx.companyId && _ctx.mode !== 'auditReport' && _ctx.enableUserRead)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 0,
                ripple: "",
                value: "Users",
                href: "#Users",
                "data-cy": "CompanyEdition-users"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("settings.users")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId && _ctx.mode !== 'auditReport')
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 1,
                ripple: "",
                value: "AccountingPeriods",
                id: "AccountingPeriodsTabCompanyEdition",
                href: "#AccountingPeriods",
                "data-cy": "CompanyEdition-accountingPeriods"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("settings.exercices")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
                    _ctx.currentUser.profile.configuration.bankAccount.read &&
                    _ctx.companyId &&
                    _ctx.mode !== 'auditReport'
                )
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 2,
                ripple: "",
                value: "Bank",
                href: "#Bank",
                "data-cy": "CompanyEdition-bank"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Banques")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId && _ctx.mode !== 'auditReport' && _ctx.isAllowedToInvoice)
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 3,
                ripple: "",
                value: "Invoices",
                href: "#Invoices",
                "data-cy": "CompanyEdition-invoices"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Ma facturation")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId && (_ctx.inAdmin() || _ctx.mode !== 'auditReport'))
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 4,
                ripple: "",
                value: "ConfigAPI",
                href: "#ConfigAPI",
                "data-cy": "CompanyEdition-configAPI"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Configuration")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId && _ctx.mode !== 'auditReport')
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 5,
                ripple: "",
                value: "Connectors",
                href: "#Connectors",
                "data-cy": "CompanyEdition-connectors"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Connecteurs")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.gainOrLossReadRight && _ctx.mode !== 'auditReport')
            ? (_openBlock(), _createBlock(_component_v_tab, {
                key: 6,
                ripple: "",
                value: "BoniMali",
                href: "#BoniMali",
                "data-cy": "CompanyEdition-boniMali"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Boni Mali")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
        class: "company-tabs-window"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, {
            key: "Company",
            value: "Company",
            style: {"background":"#f4f4f4","height":"100%"},
            class: "pt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EditCompany, {
                settingsMode: true,
                adminMode: _ctx.inAdmin(),
                companyId: _ctx.companyId,
                auditReportMode: _ctx.mode === 'auditReport'
              }, null, 8, ["adminMode", "companyId", "auditReportMode"])
            ]),
            _: 1
          }),
          (_ctx.companyId)
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: "Users",
                value: "Users",
                style: {"background":"#f4f4f4"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserTable, {
                    companyId: _ctx.companyId,
                    mode: _ctx.inAdmin() ? undefined : 'customer',
                    userTypeSelectable: false
                  }, null, 8, ["companyId", "mode"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId && _ctx.company.accountingPeriods)
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: "AccountingPeriods",
                value: "AccountingPeriods",
                style: {"background":"#f4f4f4"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AccountingPeriods, {
                    companyId: _ctx.companyId,
                    updateStore: true
                  }, null, 8, ["companyId"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.companyId)
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: "Bank",
                value: "Bank",
                style: {"background":"#f4f4f4"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BankConfig, {
                    companyId: _ctx.companyId,
                    companyBudgetInsightId: _ctx.company.budgetInsightId
                  }, null, 8, ["companyId", "companyBudgetInsightId"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_tabs_window_item, {
            key: "Invoices",
            value: "Invoices",
            style: {"background-color":"#f4f4f4"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InvoiceThemeEdition, { companyId: _ctx.companyId }, null, 8, ["companyId"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            key: "Connectors",
            value: "Connectors",
            style: {"background-color":"#f4f4f4"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Connectors, { companyId: _ctx.companyId }, null, 8, ["companyId"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, {
            key: "AccountingWorkspaces",
            value: "AccountingWorkspaces",
            style: {"background-color":"#f4f4f4"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountingWorkspaces, { accountingFirm: _ctx.company }, null, 8, ["accountingFirm"])
            ]),
            _: 1
          }),
          (_ctx.activeTab === 'ConfigAPI')
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: "ConfigAPI",
                value: "ConfigAPI"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "d-flex justify-center" }),
                  _createVNode(_component_ConfigAPI, {
                    ref: "configApi",
                    companyId: _ctx.companyId,
                    inProfileId: 
                        _ctx.company && _ctx.company.profile && _ctx.company.profile.id ? _ctx.company.profile.id : ''
                    ,
                    externalValidation: true,
                    companyIncomeCategory: 
                        _ctx.company && _ctx.company.incomeCategory ? _ctx.company.incomeCategory : ''
                    ,
                    companyTaxSystemType: 
                        _ctx.company && _ctx.company.taxSystemType ? _ctx.company.taxSystemType : ''
                    ,
                    companyLegalForm: _ctx.company && _ctx.company.legalForm ? _ctx.company.legalForm : ''
                  }, null, 8, ["companyId", "inProfileId", "companyIncomeCategory", "companyTaxSystemType", "companyLegalForm"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'BoniMali')
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: "BoniMali",
                value: "BoniMali",
                style: {"background":"#f4f4f4"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex justify-start",
                        cols: "12",
                        sm: "8"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("h1", null, "Boni Mali", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BoniMali, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}